export default __webpack_public_path__ + "static/media/princess-logo-landing-stacked.4080ebd9.svg";